<template>
  <div class="text-left mb-15">
    <div class="delivery-address">
      <el-form
        ref="userDetailsUpdate"
        :model="addressDetail"
        :rules="addressRules"
        v-if="reReneder"
      >
        <div class="mb-1">
          <el-row :gutter="10">
            <el-row :gutter="10">
              <el-col :xs="12" :sm="12" :md="6">
                <el-form-item prop="firstName">
                  <el-input
                    class="userDetail-input"
                    v-model="addressDetail.firstName"
                    :placeholder="$t('users.label.firstName')"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="12" :md="6" :sm="12">
                <el-form-item prop="lastName">
                  <el-input
                    class="userDetail-input"
                    v-model="addressDetail.lastName"
                    :placeholder="$t('users.label.lastName')"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :md="12" :sm="24">
                <el-form-item prop="email">
                  <el-input
                    class="userDetail-input"
                    v-model="addressDetail.email"
                    prop="email"
                    :placeholder="$t('users.label.email')"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :md="12" :sm="24">
                <el-form-item prop="phone">
                  <el-input
                    class="userDetail-input"
                    v-model="addressDetail.phone"
                    prop="email"
                    :placeholder="$t('users.label.phone')"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="mt-30">
              <h5>{{ $t("users.deliveryAddress.billingAddress") }}</h5>
            </el-row>
          </el-row>
        </div>
        <el-row>
          <el-col :xs="12" :sm="22" :md="12">
            <el-form-item prop="rue">
              <el-input
                class="userDetail-input"
                v-model="addressDetail.rue"
                :placeholder="$t('users.deliveryAddress.rue')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="12" :sm="6" :md="6">
            <el-form-item prop="ville">
              <el-input
                class="userDetail-input"
                v-model="addressDetail.ville"
                :placeholder="$t('users.deliveryAddress.ville')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="12" :sm="6" :md="6">
            <el-form-item>
              <el-input
                class="userDetail-input"
                v-model="getCountryCode"
                :placeholder="$t('users.deliveryAddress.ville')"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item prop="codePostal">
              <el-input
                class="userDetail-input"
                v-model="addressDetail.codePostal"
                :placeholder="$t('users.deliveryAddress.codePostal')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="12" :sm="6" :md="6">
            <el-checkbox
              v-model="addressDetail.copyAddress"
              @change="setSameAddress()"
            >
              {{ $t("users.deliveryAddress.copyAddress") }}
            </el-checkbox>
          </el-col>
        </el-row>
        <div v-if="showDeliveryAddress">
          <el-row class="mt-10">
            <h5>{{ $t("users.deliveryAddress.deliveryAddress") }}</h5>
          </el-row>
          <el-row>
            <el-col :xs="12" :sm="23" :md="12">
              <el-form-item prop="rue2">
                <el-input
                  class="userDetail-input"
                  v-model="addressDetail.rue2"
                  :placeholder="$t('users.deliveryAddress.rue')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="12" :sm="6" :md="6">
              <el-form-item prop="ville">
                <el-input
                  class="userDetail-input"
                  v-model="addressDetail.ville2"
                  :placeholder="$t('users.deliveryAddress.ville')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="12" :sm="6" :md="6">
              <el-form-item prop="province2">
                <el-input
                class="userDetail-input"
                v-model="getCountryCode"
                :placeholder="$t('users.deliveryAddress.ville')"
                disabled
              />
                <!-- <el-select
                  v-model="addressDetail.province2"
                  :placeholder="$t('users.deliveryAddress.province')"
                >
                  <el-option
                    v-for="province in provinces"
                    :key="province.id"
                    :label="province.name"
                    :value="province.id"
                  >
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6">
              <el-form-item prop="codePostal">
                <el-input
                  class="userDetail-input"
                  v-model="addressDetail.codePostal2"
                  :placeholder="$t('users.deliveryAddress.codePostal')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row class="text-left mt-15">
          <el-button
            type="primary"
            native-type="submit"
            class="ctaSubmit"
            @click="updateUserDetails"
          >
            {{ ctaSubmitText }}
          </el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import userApi from "@/api/user";
export default {
  components: {},
  props: {
    ctaSubmitText: {
      type: String,
      default: () => this.$i18n.t("products.filters.button.cancel"),
    },
    shippingAddress: {
      type: Object,
      default: () => {},
    },
    billingAddress: {
      type: Object,
      default: () => {},
    },
    countries: {
      default: () => [],
    },
    checkOut: {
      default: () => false,
    },
    userDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    // For guest checkout, restore the previously entered fields when the
    // form is re-mounted (e.g. user clicks "Edit"). The submit handler
    // persists `addressDetail` to localStorage as `guestUserDetails`, but
    // `this.user` is empty for guests so props alone can't rehydrate.
    let stored = null;
    if (!localStorage.getItem("access-token")) {
      try {
        stored = JSON.parse(localStorage.getItem("guestUserDetails") || "null");
      } catch (e) {
        stored = null;
      }
    }
    const pick = (storedKey, propValue) =>
      stored && stored[storedKey] != null ? stored[storedKey] : propValue;

    return {
      addressDetail: {
        rue: pick("rue", this.billingAddress.street),
        ville: pick("ville", this.billingAddress.city),
        // province: this.billingAddress.state.id,
        codePostal: pick("codePostal", this.billingAddress.postalCode),
        copyAddress: stored && stored.copyAddress != null ? stored.copyAddress : true,
        rue2: pick("rue2", this.shippingAddress.street),
        ville2: pick("ville2", this.shippingAddress.city),
        // `state` is absent on accounts whose shipping address was never given a
        // province, and this runs inside data() — an unguarded `.id` threw before
        // the component existed, taking the whole checkout page down. The billing
        // equivalent on the line above was already commented out for this reason.
        province2: pick("province2", this.shippingAddress.state && this.shippingAddress.state.id),
        codePostal2: pick("codePostal2", this.shippingAddress.postalCode),
        firstName: pick("firstName", this.userDetail.firstName),
        lastName: pick("lastName", this.userDetail.lastName),
        email: pick("email", this.userDetail.email),
        phone: pick("phone", this.userDetail.phone),
      },
      options: [],
      value: "",
      addressRules: {
        rue: [
          {
            required: true,
            message: this.$i18n.t("users.deliveryAddress.formRequiredMsg.rue"),
            trigger: "blur",
          },
        ],
        ville: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.ville"
            ),
            trigger: "blur",
          },
        ],
        // province: [
        //   {
        //     required: true,
        //     message: this.$i18n.t(
        //       "users.deliveryAddress.formRequiredMsg.province"
        //     ),
        //     trigger: "blur",
        //   },
        // ],
        codePostal: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.codePostal"
            ),
            trigger: "blur",
          },
        ],
        rue2: [
          {
            required: true,
            message: this.$i18n.t("users.deliveryAddress.formRequiredMsg.rue2"),
            trigger: "blur",
          },
        ],
        firstName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.firstName"
            ),
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.lastName"
            ),
          },
        ],
        email: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.email"
            ),
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: this.$i18n.t(
              "users.deliveryAddress.formPatternMsg.email"
            ),
            trigger: ['blur', 'change']
          }
        ],
        phone: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.phone"
            ),
            trigger: "blur",
          },
          {
            pattern: /^(\d{3}\s?\d{3}\s?\d{4})$/,
            message: this.$i18n.t(
              "users.deliveryAddress.formPatternMsg.phone"
            ),
            trigger: ['blur', 'change']
          }
        ],
      },
      showDeliveryAddress: false,
      defaultCountries: {
        name: "Canada",
        id: "1",
      },
      reReneder: true,
    };
  },
  watch: {
    toggleResetFields() {
      this.resetFields();
    },
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("configuration", ["actionBar"]),
    ...mapGetters("user", ["isLoggedIn"]),

    getCountryCode() {
      if (this.$i18n.locale == "en-US") {
        const countryCode = this.actionBar.country == 'ON' ? 'Ontario' : 'Quebec'
        return countryCode
      } 
      return this.actionBar.country == 'ON' ? 'Ontario' : 'Québec'
    },
    // provinces() {
    //   const provinces = this.countries.filter(
    //     (p) => p.id != null && p.code === "CA"
    //   );
    //   const provincesArr = provinces[0].regions.filter(
    //     (s) => s.id != null && (s.name === "Ontario" || s.name === "Québec")
    //   );
    //   return provincesArr;
    // },
  },
  created() {},
  methods: {
    resetFields() {
      this.$refs.registerForm.resetFields();
    },
    setSameAddress() {
      this.showDeliveryAddress =
        this.addressDetail.copyAddress == false ? true : false;
    },
    updateUserDetails(e) {
      
      e.preventDefault();
      const vm = this;
      this.$refs.userDetailsUpdate.validate().then((valid) => {
        if (valid) {
          var billingAddress = {
            street: this.addressDetail.rue,
            city: this.addressDetail.ville,
            state: {
              id: this.actionBar.country == 'ON' ? 2 : 1,
            },
            country: {
              id: this.defaultCountries.id,
            },
            postalCode: this.addressDetail.codePostal,
          };
          var shippingAddress = {
            street: this.addressDetail.rue2,
            city: this.addressDetail.ville2,
            state: {
              id: this.actionBar.country == 'ON' ? 2 : 1,
            },
            country: {
              id: this.defaultCountries.id,
            },
            postalCode: this.addressDetail.codePostal2,
          };
          if (!this.isLoggedIn) {
            localStorage.setItem("guestUserDetails", JSON.stringify(this.addressDetail));
            this.$emit("emit-update-details");
            return; 
          }
          userApi
            .updateUser(this.user.id, {
              firstName: vm.addressDetail.firstName,
              lastName: vm.addressDetail.lastName,
              email: vm.addressDetail.email,
              phone: vm.addressDetail.phone,
            })
            .then((data) => {
              if (data) {
                const userData = {
                  firstName: vm.addressDetail.firstName,
                  lastName: vm.addressDetail.lastName,
                  email: vm.addressDetail.email,
                  phone: vm.addressDetail.phone,
                  billingAddress: billingAddress,
                };

                if (this.showDeliveryAddress) {
                  userData.shippingAddress = shippingAddress;
                }

                userApi
                  .updateUser(this.user.id, userData)
                  .then((data) => {
                    if (data) {
                      if (this.checkOut) {
                        this.$emit("emit-update-details");
                      }
                    } else {
                      vm.$emit("error", "cannot authenticate user");
                    }
                  })
                  .catch((error) => {
                    vm.$emit("error", error);
                  });
              } else {
                vm.$emit("error", "cannot authenticate user");
              }
            })
            .catch((error) => {
              vm.$emit("error", error);
            });
        }
      });
    },
    reRenderForm() {
      this.reRender = false;
      this.$nextTick(() => {
        this.reRender = true;
      });
    },
  },
  mounted() {
    this.$root.$on("chanLang", () => {
      this.reRenderForm();
      this.addressRules = {
        rue: [
          {
            required: true,
            message: this.$i18n.t("users.deliveryAddress.formRequiredMsg.rue"),
            trigger: "blur",
          },
        ],
        ville: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.ville"
            ),
            trigger: "blur",
          },
        ],
        province: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.province"
            ),
            trigger: "blur",
          },
        ],
        codePostal: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.codePostal"
            ),
            trigger: "blur",
          },
        ],
        rue2: [
          {
            required: true,
            message: this.$i18n.t("users.deliveryAddress.formRequiredMsg.rue2"),
            trigger: "blur",
          },
        ],
        firstName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.firstName"
            ),
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.lastName"
            ),
          },
        ],
        email: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.email"
            ),
          },
        ],
        phone: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.phone"
            ),
          },
        ],
      };
    });
  },
};
</script>

<style scoped>
.delivery-address .el-select {
  border: 1px solid #dcdfe6;
}
.ctaSubmit {
  width: 150px;
  height: 40px;
}
.password-icon-class-register {
  cursor: pointer;
  width: 20px;
  margin-right: 10px;
}
.register-input .el-input__inner {
  margin: 0px !important;
}
</style>
